import { CurvasScreen } from "@/screens/financeiro/configuracoes/curvas";

export function FinanceiroCurvasPage() {
  return <CurvasScreen />;
}
